import { inject, onMounted, onUnmounted, ref } from 'vue';
import { I18nInjectionKey } from 'vue-i18n';

/**
 * Composition cho phép add event vào element khi component đc mount và xóa event khi component unmount
 * @param {*} target HTML element
 * @param {string} event Tên event
 * @param {function} callback Hàm thực hiện khi kích hoạt event
 * @param {boolean} addEventWhenMounted Có add event ngay khi mounted ko
 */
export const useEventListener = (target, event, callback, addEventWhenMounted = false) => {
  /**
   * Add Event
   */
  const addEvent = () => {
    target.addEventListener(event, callback);
  };
  
  /**
   * Remove Event
   */
  const removeEvent = () => {
    target.removeEventListener(event, callback);
  };

  onMounted(() => {
    if (addEventWhenMounted) {
      addEvent();
    }
  });

  onUnmounted(() => removeEvent());

  return {
    addEvent,
    removeEvent,
  };
};


/**
 * Composition cho phép add timeout và clear timeout khi unmount component
 */
export const useTimeout = () => {
  const timeOutFunc = ref({});

  /**
   * Hàm setTimeout
   * @param {function} callback Function
   * @param {number} delay Thời gian chở
   * @param {*} key Key để xác định hàm nào
   */
  const runTimeoutFunc = (callback, delay, key) => {
    if (!key) {
      console.error('Cần truyền key');
      return;
    }
    clearTimeout(timeOutFunc.value[key]);
    timeOutFunc.value[key] = setTimeout(callback, delay);
  }

  onUnmounted(() => {
    for (const key in timeOutFunc.value) {
      clearTimeout(timeOutFunc.value[key]);
    }
  });

  return { runTimeoutFunc };
}

/**
 * I18n
 * @author: BMThang(16/05/2023) 
 */
export const useI18n = () => {
  const { t } = inject(I18nInjectionKey)
  return { t }
}